export default "__VITE_ASSET__D4VZq2wq__"